import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#D8FFFF"
      d="M101.257 22.002a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M92.706 10.166a1.5 1.5 0 0 1 0 2.121L82.71 22.28a1.5 1.5 0 0 1-2.12-2.121l9.993-9.993a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M80.59 10.166a1.5 1.5 0 0 1 2.121 0l9.995 9.993a1.5 1.5 0 0 1-2.122 2.121l-9.994-9.993a1.5 1.5 0 0 1 0-2.121"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M49.44 109.13a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M13.633 65.097a1.5 1.5 0 0 1 1.5 1.5V80.73a1.5 1.5 0 0 1-3 0V66.597a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M5.066 73.664a1.5 1.5 0 0 1 1.5-1.5H20.7a1.5 1.5 0 1 1 0 3H6.566a1.5 1.5 0 0 1-1.5-1.5M24.594 95.32a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M58.704 89.338H34.535a5.144 5.144 0 0 1-5.144-5.144v-56.58a5.144 5.144 0 0 1 5.144-5.144h36.45c1.362 0 2.67.542 3.633 1.505l9.85 9.849a5.14 5.14 0 0 1 1.504 3.634v44.619a7.26 7.26 0 0 1-7.26 7.26z"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M39.706 42.316a2.25 2.25 0 0 1 2.25-2.25h33.027a2.25 2.25 0 0 1 0 4.5H41.956a2.25 2.25 0 0 1-2.25-2.25M39.706 55.904a2.25 2.25 0 0 1 2.25-2.25h29.57a2.25 2.25 0 0 1 0 4.5h-29.57a2.25 2.25 0 0 1-2.25-2.25M47.737 70.192a1.5 1.5 0 0 1 0 2.122l-4.72 4.72a1.5 1.5 0 1 1-2.122-2.122l4.72-4.72a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M40.895 70.192a1.5 1.5 0 0 1 2.122 0l4.72 4.72a1.5 1.5 0 1 1-2.122 2.122l-4.72-4.72a1.5 1.5 0 0 1 0-2.122M52.774 75.973a1.5 1.5 0 0 1 1.5-1.5h7.404a1.5 1.5 0 1 1 0 3h-7.404a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      d="m69.577 94.595 11.93-7.063-9.981-7.3-3.114 13.511a.785.785 0 0 0 1.165.852"
    />
    <path
      fill="#0597A3"
      d="m81.259 66.923 9.982 7.3zl-9.733 13.31 9.982 7.3 10-13.675-9.93-7.372z"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M98.12 49.948a2.59 2.59 0 0 1 3.632-.5l8.816 6.685a2.59 2.59 0 0 1 .535 3.582L99.27 76.111a2.591 2.591 0 1 1-4.203-3.033l10.352-14.344-6.799-5.156a2.59 2.59 0 0 1-.5-3.63"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      d="m81.578 66.486 9.93 7.372 12.07-16.504-9.914-7.394z"
    />
    <path
      fill="#0597A3"
      d="M106.961 49.66a6.184 6.184 0 0 0-11.101-2.702l-2.196 3.001 9.915 7.394 2.264-3.096a6.19 6.19 0 0 0 1.119-4.599z"
    />
  </svg>
);
const SvgEnrichedIconContractBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconContractBrand);
export default Memo;
